import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import PatientList from './components/PatientList';
import PatientDetail from './components/PatientDetail';
import Analytics from './components/Analytics';
import Settings from './components/Settings';
import Help from './components/Help';
import Layout from './components/Layout';
import CareTeamDashboard from './components/CareTeamDashboard';
import CareTeamInbox from './components/CareTeamInbox';
import MessagesInbox from './components/MessagesInbox';
import NudgeCenter from './components/NudgeCenter';
import CohortBuilder from './components/CohortBuilder';
import { Toaster } from './components/ui/sonner';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }

    // Remove injected badge
    const removeBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) badge.remove();
      document.title = 'HealthLink360';
    };
    removeBadge();
    const interval = setInterval(removeBadge, 300);
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => { clearInterval(interval); observer.disconnect(); };
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              !isAuthenticated ? (
                <Login onLogin={handleLogin} />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            }
          />
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <Dashboard />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/dashboard"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <Dashboard />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/patients"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <PatientList />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/patients/:patientId"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <PatientDetail />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/analytics"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <Analytics />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/settings"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <Settings user={user} onLogout={handleLogout} />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/help"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <Help />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/careteam"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <CareTeamDashboard />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/careteam/inbox"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <CareTeamInbox />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/messages"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <MessagesInbox />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/nudges"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <NudgeCenter />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/cohorts"
            element={
              isAuthenticated ? (
                <Layout user={user} onLogout={handleLogout}>
                  <CohortBuilder />
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
